(() => {
  const PICKER_SELECTOR = "[data-clean-delivery-picker]";

  const TIMEZONE = "Asia/Kolkata";
  const DAY_NAMES = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const SHORT_DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const TIME_SLOTS = [
    { label: "9:00 AM - 11:59 AM", start: "09:00", end: "11:59" },
    { label: "12:00 PM - 2:59 PM", start: "12:00", end: "14:59" },
    { label: "3:00 PM - 5:59 PM", start: "15:00", end: "17:59" },
    { label: "6:00 PM - 9:00 PM", start: "18:00", end: "21:00" },
  ];
  const ZIPCODE_DEFAULT = {
    enabled: false,
    showCountry: false,
    placeholder: "Enter pincode",
    availableText: "Delivery available",
    unavailableText: "Delivery not available",
    blockAddToCart: true,
    persistLastPincode: true,
    rules: [],
    assignments: [],
    visibility: {
      showOnProduct: true,
      message: "Delivery is not available for this pincode.",
    },
  };
  const STANDARD_LEAD = { default: 5, 0: 6, 6: 7 };
  const WINNI_C_LEAD = { default: 9, 0: 10, 6: 11 };
  const POSTDIWALI_LEAD = { default: 8, 0: 9, 6: 10 };
  const MAX_DAYS_AHEAD = 90;
  const IST_PARTS_FORMATTER = new Intl.DateTimeFormat("en-US", {
    timeZone: TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  });

  const VALENTINE_COLLECTIONS = [
    "Chocolate Day Gifts",
    "Hug Day Gifts",
    "Kiss Day Gifts",
    "Lovers Day Gifts",
    "Promise Day Gifts",
    "Propose Day",
    "Rose Day Gifts",
    "Teddy Day",
    "Valentine Day Personalized",
  ];

  const DIWALI_COLLECTIONS = [
    "Exclusive Diwali 999 Store Deals",
    "Festive Diwali Chocolate Gift Box",
    "Diwali Collections",
    "Diwali Diyas",
    "Shop Diwali Diyas Online",
    "Diwali Dry Fruits - Perfect Festival Gift",
    "Diwali Gift Hampers for All Occasions",
    "Diwali Gifts",
    "Diwali Gifts Online for Every Budget",
    "Diwali Gifts Under 700 Online Shop",
    "Send Diwali Gifts to Australia",
    "Send Diwali Gifts to Canada Effortlessly",
    "Send Delightful Diwali Gifts to Singapore",
    "Diwali Gifts to UAE with Free Shipping",
    "Send Diwali Gifts to UK",
    "Send Diwali Gifts to USA - Comprehensive Selection",
    "Shop Festive Diwali Home Decor Online",
    "Diwali Home Decor Gifts",
    "Diwali Metal Diyas",
    "Diwali Mithai",
    "Diwali Sweets",
    "diwali-decoration-ideas",
    "diwali-express-delivery",
    "Diwali Gift Hampers for Festive Celebrations",
    "Personalised Diwali Gifts",
    "send Diwali gifts to Hyderabad",
  ];

  const CORPORATE_DIWALI_COLLECTIONS = [
    "Corporate Gift Bags for Diwali",
    "Corporate Diwali Chocolate Gift Hampers",
    "Corporate Diwali Dry Fruit Hampers",
    "Corporate Diwali Gifts",
    "Corporate Diwali Gifts for Partners",
    "Corporate Diwali Gifts for Clients and Employees",
    "Corporate Diwali Gifts Employees | Thoughtful Collection",
    "Corporate Diwali Gifts Online Above 4000",
    "Corporate Diwali Gifts Online Under \u20b92500",
    "Corporate Diwali Gifts Online Under 3999",
    "Corporate Diwali Gifts Under 999",
    "Premium Corporate Diwali Gift Hampers",
    "Corporate Diwali Sweets",
    "Diwali Corporate Gifts for Businesses",
    "Corporate Gifts Under 4000",
  ];

  const DEFAULT_CONFIG = {
    version: 1,
    timezone: TIMEZONE,
    maxDaysAhead: MAX_DAYS_AHEAD,
    propertyNames: {
      date: "Delivery Date",
      day: "Delivery Day",
      time: "Delivery Time",
    },
    productGroups: [
      {
        id: "same-day",
        name: "Same day delivery",
        enabled: true,
        priority: 10,
        match: { tags: ["same day delivery"], collections: [] },
        dateRuleId: "same-day-date",
        timeSlotRuleId: "same-day-slots",
      },
      {
        id: "winni-c",
        name: "Winni C",
        enabled: true,
        priority: 20,
        match: { tags: ["winni_c"], collections: [] },
        dateRuleId: "winni-c-9-10-11",
        timeSlotRuleId: "none",
      },
      {
        id: "postdiwali",
        name: "Post Diwali",
        enabled: true,
        priority: 30,
        match: { tags: ["postdiwali"], collections: [] },
        dateRuleId: "postdiwali-8-9-10",
        timeSlotRuleId: "none",
      },
      {
        id: "valentine",
        name: "Valentine collections",
        enabled: true,
        priority: 40,
        match: { tags: [], collections: VALENTINE_COLLECTIONS },
        dateRuleId: "standard-5-6-7",
        timeSlotRuleId: "none",
      },
      {
        id: "diwali",
        name: "Diwali collections",
        enabled: true,
        priority: 50,
        match: { tags: [], collections: DIWALI_COLLECTIONS },
        dateRuleId: "standard-5-6-7",
        timeSlotRuleId: "none",
      },
      {
        id: "corporate-diwali",
        name: "Corporate Diwali collections",
        enabled: true,
        priority: 60,
        match: { tags: [], collections: CORPORATE_DIWALI_COLLECTIONS },
        dateRuleId: "standard-5-6-7",
        timeSlotRuleId: "none",
      },
      {
        id: "default",
        name: "Default fallback",
        enabled: true,
        priority: 9999,
        match: { tags: [], collections: [] },
        dateRuleId: "standard-5-6-7",
        timeSlotRuleId: "none",
      },
    ],
    dateRules: [
      {
        id: "standard-5-6-7",
        name: "Standard 5/6/7 day shipping",
        deliveryMethod: "shipping",
        availableWeekdays: [0, 1, 2, 3, 4, 5, 6],
        leadDays: STANDARD_LEAD,
        cutoffTime: "23:59",
        maxDaysAhead: MAX_DAYS_AHEAD,
        disabledDates: [],
      },
      {
        id: "same-day-date",
        name: "Same day local delivery",
        deliveryMethod: "local_delivery",
        availableWeekdays: [0, 1, 2, 3, 4, 5, 6],
        leadDays: { default: 0 },
        cutoffTime: "14:00",
        maxDaysAhead: MAX_DAYS_AHEAD,
        disabledDates: [],
      },
      {
        id: "winni-c-9-10-11",
        name: "Winni C 9/10/11 day shipping",
        deliveryMethod: "shipping",
        availableWeekdays: [0, 1, 2, 3, 4, 5, 6],
        leadDays: WINNI_C_LEAD,
        cutoffTime: "23:59",
        maxDaysAhead: MAX_DAYS_AHEAD,
        disabledDates: [],
      },
      {
        id: "postdiwali-8-9-10",
        name: "Post Diwali 8/9/10 day shipping",
        deliveryMethod: "shipping",
        availableWeekdays: [0, 1, 2, 3, 4, 5, 6],
        leadDays: POSTDIWALI_LEAD,
        cutoffTime: "23:59",
        maxDaysAhead: MAX_DAYS_AHEAD,
        disabledDates: [],
      },
    ],
    timeSlotRules: [
      {
        id: "none",
        name: "No time slots",
        enabled: false,
        required: false,
        initiallyDeselected: true,
        hideUnavailableSlots: true,
        preparationMinutes: 0,
        slots: [],
      },
      {
        id: "same-day-slots",
        name: "Same day time slots",
        enabled: true,
        required: true,
        initiallyDeselected: true,
        hideUnavailableSlots: true,
        preparationMinutes: 0,
        slots: TIME_SLOTS,
      },
    ],
  };

  const normalize = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");

  const getEntityText = (value) => {
    if (!value || typeof value !== "object") return value;
    return value.title || value.handle || value.id || "";
  };

  const escapeHtml = (value) =>
    String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");

  const normalizeList = (values = []) =>
    values.map((value) => normalize(getEntityText(value))).filter(Boolean);

  const hasAny = (source, targets) => {
    const sourceSet = new Set(source);
    return targets.some((target) => sourceSet.has(normalize(target)));
  };

  const clone = (value) => JSON.parse(JSON.stringify(value));

  const intValue = (value, fallback = 0) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const normalizePincode = (value) =>
    String(value || "")
      .trim()
      .replace(/\D/g, "")
      .slice(0, 6);

  const normalizeZipcodeValidation = (raw) => {
    const source = raw && typeof raw === "object" ? raw : {};
    const defaults = clone(ZIPCODE_DEFAULT);

    return {
      ...defaults,
      enabled: source.enabled === true,
      showCountry: source.showCountry === true,
      placeholder: String(source.placeholder || defaults.placeholder),
      availableText: String(source.availableText || defaults.availableText),
      unavailableText: String(
        source.unavailableText || defaults.unavailableText,
      ),
      blockAddToCart: source.blockAddToCart !== false,
      persistLastPincode: source.persistLastPincode !== false,
      rules: Array.isArray(source.rules)
        ? source.rules.map((rule) => ({
            id: String(rule?.id || ""),
            name: String(rule?.name || ""),
            panIndia: rule?.panIndia === true,
            status: rule?.status === "deactivate" ? "deactivate" : "activate",
            ruleType:
              rule?.ruleType === "blacklist" ? "blacklist" : "whitelist",
            priority: intValue(rule?.priority, 100),
            estimatedDays: String(rule?.estimatedDays || ""),
            zips: Array.isArray(rule?.zips)
              ? rule.zips.map((zip) => ({
                  zip: String(zip?.zip || zip || "").trim(),
                  estimatedDays: String(
                    zip?.estimatedDays || zip?.estimate || "",
                  ),
                  cod: zip?.cod === true,
                  type: String(zip?.type || ""),
                }))
              : [],
          }))
        : [],
      assignments: Array.isArray(source.assignments)
        ? source.assignments.map((assignment) => ({
            id: String(assignment?.id || ""),
            ruleId: String(assignment?.ruleId || ""),
            type: ["all_products", "products", "collections"].includes(
              assignment?.type,
            )
              ? assignment.type
              : "all_products",
            targets: Array.isArray(assignment?.targets)
              ? assignment.targets.map((target) => ({
                  id: String(
                    target?.id || target?.handle || target?.title || "",
                  ),
                  handle: String(target?.handle || target?.id || ""),
                  title: String(
                    target?.title || target?.handle || target?.id || "",
                  ),
                }))
              : [],
          }))
        : [],
      visibility: {
        ...defaults.visibility,
        ...(source.visibility && typeof source.visibility === "object"
          ? source.visibility
          : {}),
        showOnProduct: source.visibility?.showOnProduct !== false,
        message: String(
          source.visibility?.message || defaults.visibility.message,
        ),
      },
    };
  };

  const normalizeConfig = (config) => {
    if (!config || typeof config !== "object") return clone(DEFAULT_CONFIG);

    const normalized = {
      ...clone(DEFAULT_CONFIG),
      ...config,
      productGroups: Array.isArray(config.productGroups)
        ? config.productGroups
        : DEFAULT_CONFIG.productGroups,
      dateRules: Array.isArray(config.dateRules)
        ? config.dateRules
        : DEFAULT_CONFIG.dateRules,
      timeSlotRules: Array.isArray(config.timeSlotRules)
        ? config.timeSlotRules
        : DEFAULT_CONFIG.timeSlotRules,
      zipcodeValidation: Object.prototype.hasOwnProperty.call(
        config,
        "zipcodeValidation",
      )
        ? normalizeZipcodeValidation(config.zipcodeValidation)
        : clone(ZIPCODE_DEFAULT),
    };

    if (!normalized.productGroups.length || !normalized.dateRules.length) {
      return clone(DEFAULT_CONFIG);
    }

    return normalized;
  };

  const parseProductData = (picker) => {
    const dataScript = picker.querySelector("[data-clean-delivery-product]");

    if (!dataScript?.textContent)
      return { id: "", handle: "", title: "", tags: [], collections: [] };

    try {
      const data = JSON.parse(dataScript.textContent);
      return {
        id: String(data.id || ""),
        handle: String(data.handle || ""),
        title: String(data.title || ""),
        tags: Array.isArray(data.tags) ? data.tags : [],
        collections: Array.isArray(data.collections) ? data.collections : [],
      };
    } catch (error) {
      return { id: "", handle: "", title: "", tags: [], collections: [] };
    }
  };

  const parseConfigData = (picker) => {
    const dataScript = picker.querySelector("[data-clean-delivery-config]");

    if (!dataScript?.textContent) return clone(DEFAULT_CONFIG);

    try {
      const parsed = JSON.parse(dataScript.textContent);
      return normalizeConfig(
        typeof parsed === "string" ? JSON.parse(parsed) : parsed,
      );
    } catch (error) {
      return clone(DEFAULT_CONFIG);
    }
  };

  const productMatchesGroup = (group, tags, collections) => {
    const match = group.match || {};
    const matchTags = normalizeList(match.tags || []);
    const matchCollections = normalizeList(match.collections || []);

    if (!matchTags.length && !matchCollections.length)
      return group.id === "default";

    return hasAny(tags, matchTags) || hasAny(collections, matchCollections);
  };

  const getRule = (productData, config) => {
    const tags = normalizeList(productData.tags);
    const collections = normalizeList(productData.collections);
    const groups = [...config.productGroups]
      .filter((group) => group && group.enabled !== false)
      .sort((a, b) => intValue(a.priority, 9999) - intValue(b.priority, 9999));
    const group =
      groups.find((candidate) =>
        productMatchesGroup(candidate, tags, collections),
      ) ||
      groups.find((candidate) => candidate.id === "default") ||
      DEFAULT_CONFIG.productGroups.find(
        (candidate) => candidate.id === "default",
      );
    const dateRule =
      config.dateRules.find(
        (candidate) => candidate.id === group?.dateRuleId,
      ) || DEFAULT_CONFIG.dateRules[0];
    const timeSlotRule =
      config.timeSlotRules.find(
        (candidate) => candidate.id === group?.timeSlotRuleId,
      ) || DEFAULT_CONFIG.timeSlotRules[0];

    return {
      id: group?.id || "default",
      dateRule,
      timeSlotRule,
      timeRequired:
        timeSlotRule.enabled === true && timeSlotRule.required === true,
    };
  };

  const getDateRuleById = (
    config,
    id,
    fallback = DEFAULT_CONFIG.dateRules[0],
  ) =>
    config.dateRules.find((candidate) => candidate.id === id) ||
    DEFAULT_CONFIG.dateRules.find((candidate) => candidate.id === id) ||
    fallback;

  const getTimeSlotRuleById = (
    config,
    id,
    fallback = DEFAULT_CONFIG.timeSlotRules[0],
  ) =>
    config.timeSlotRules.find((candidate) => candidate.id === id) ||
    DEFAULT_CONFIG.timeSlotRules.find((candidate) => candidate.id === id) ||
    fallback;

  const getDateOnlyRule = (config, id = "standard") => {
    const dateRule = getDateRuleById(config, "standard-5-6-7");
    const timeSlotRule = getTimeSlotRuleById(config, "none");

    return {
      id,
      dateRule,
      timeSlotRule,
      timeRequired: false,
    };
  };

  const getSameDayRule = (config) => {
    const dateRule = getDateRuleById(config, "same-day-date");
    const timeSlotRule = getTimeSlotRuleById(config, "same-day-slots");

    return {
      id: "same_day",
      dateRule,
      timeSlotRule,
      timeRequired:
        timeSlotRule.enabled === true && timeSlotRule.required === true,
    };
  };

  const getProductDeliveryFlow = (productData) => {
    const tags = normalizeList(productData.tags || []);

    if (tags.includes("same day delivery")) return "same_day";
    return "standard";
  };

  const targetMatchesEntity = (target, entity) => {
    if (!target || !entity) return false;

    const targetValues = [target.id, target.handle, target.title].filter(
      Boolean,
    );
    const entityValues = [entity.id, entity.handle, entity.title].filter(
      Boolean,
    );
    const normalizedEntityValues = entityValues.map(normalize);

    return targetValues.some((targetValue) => {
      const rawTarget = String(targetValue || "").trim();
      return (
        entityValues.some((entityValue) => String(entityValue) === rawTarget) ||
        normalizedEntityValues.includes(normalize(rawTarget))
      );
    });
  };

  const getApplicableZipcodeRules = (productData, zipcodeConfig) => {
    const rules = Array.isArray(zipcodeConfig.rules) ? zipcodeConfig.rules : [];
    const activeRules = rules.filter((rule) => rule.status === "activate");
    const assignments = Array.isArray(zipcodeConfig.assignments)
      ? zipcodeConfig.assignments
      : [];

    const sameDayFallbackRules = normalizeList(productData.tags || []).includes(
      "same day delivery",
    )
      ? activeRules.filter((rule) => normalize(rule.id) === "same-day-delivery")
      : [];

    if (!assignments.length) return sameDayFallbackRules.slice(0, 1);

    const productEntity = {
      id: String(productData.id || ""),
      handle: productData.handle || "",
      title: productData.title || "",
    };
    const collectionEntities = Array.isArray(productData.collections)
      ? productData.collections.map((collection) =>
          collection && typeof collection === "object"
            ? {
                id: String(collection.id || ""),
                handle: collection.handle || "",
                title: collection.title || "",
              }
            : { id: "", handle: "", title: String(collection || "") },
        )
      : [];
    const applicable = [];
    const assignmentSpecificity = {
      products: 0,
      collections: 1,
      all_products: 2,
    };

    assignments.forEach((assignment, assignmentIndex) => {
      const rule = activeRules.find(
        (candidate) => candidate.id === assignment.ruleId,
      );
      if (!rule) return;

      if (assignment.type === "all_products") {
        applicable.push({
          assignmentIndex,
          rule,
          specificity: assignmentSpecificity.all_products,
        });
        return;
      }

      const targets = Array.isArray(assignment.targets)
        ? assignment.targets
        : [];

      if (
        assignment.type === "products" &&
        targets.some((target) => targetMatchesEntity(target, productEntity))
      ) {
        applicable.push({
          assignmentIndex,
          rule,
          specificity: assignmentSpecificity.products,
        });
        return;
      }

      if (
        assignment.type === "collections" &&
        targets.some((target) =>
          collectionEntities.some((collection) =>
            targetMatchesEntity(target, collection),
          ),
        )
      ) {
        applicable.push({
          assignmentIndex,
          rule,
          specificity: assignmentSpecificity.collections,
        });
      }
    });

    if (!applicable.length) return sameDayFallbackRules.slice(0, 1);

    const bestSpecificity = Math.min(
      ...applicable.map((candidate) => candidate.specificity),
    );
    const uniqueByRule = new Map();

    applicable
      .filter((candidate) => candidate.specificity === bestSpecificity)
      .forEach((candidate) => {
        if (!uniqueByRule.has(candidate.rule.id)) {
          uniqueByRule.set(candidate.rule.id, candidate);
        }
      });

    const prioritizedRules = [...uniqueByRule.values()]
      .sort((a, b) => {
        const priorityDifference =
          intValue(a.rule.priority, 100) - intValue(b.rule.priority, 100);
        if (priorityDifference) return priorityDifference;

        const estimateDifference =
          Number(!normalize(a.rule.estimatedDays)) -
          Number(!normalize(b.rule.estimatedDays));
        if (estimateDifference) return estimateDifference;

        const panIndiaDifference =
          Number(a.rule.panIndia === true) - Number(b.rule.panIndia === true);
        if (panIndiaDifference) return panIndiaDifference;

        return a.assignmentIndex - b.assignmentIndex;
      })
      .map((candidate) => candidate.rule);

    return prioritizedRules.slice(0, 1);
  };

  const normalizeZipToken = (value) =>
    String(value || "")
      .trim()
      .replace(/\s+/g, "");

  const zipInRange = (rangeZip, pincode) => {
    const parts = normalizeZipToken(rangeZip).split(/[-–—]/);
    if (parts.length !== 2) return false;

    const from = Number.parseInt(parts[0], 10);
    const to = Number.parseInt(parts[1], 10);
    const pin = Number.parseInt(pincode, 10);

    return (
      Number.isFinite(from) &&
      Number.isFinite(to) &&
      Number.isFinite(pin) &&
      pin >= Math.min(from, to) &&
      pin <= Math.max(from, to)
    );
  };

  const zipHasRange = (zip) => /[-–—]/.test(zip);

  const zipMatches = (rule, pincode) => {
    if (!pincode) return false;
    if (rule.panIndia) return true;

    return (rule.zips || []).some((entry) => {
      const zip = normalizeZipToken(entry?.zip || entry);
      return zip === pincode || (zipHasRange(zip) && zipInRange(zip, pincode));
    });
  };

  const ruleHasZipCoverage = (rule) =>
    rule.panIndia === true ||
    (Array.isArray(rule.zips) &&
      rule.zips.some((entry) => normalizeZipToken(entry?.zip || entry)));

  const checkZipcode = (pincode, productData, zipcodeConfig) => {
    const normalizedPincode = normalizePincode(pincode);
    const defaultMessage =
      zipcodeConfig.visibility?.message || ZIPCODE_DEFAULT.visibility.message;
    const allRules = Array.isArray(zipcodeConfig.rules)
      ? zipcodeConfig.rules
      : [];
    const assignments = Array.isArray(zipcodeConfig.assignments)
      ? zipcodeConfig.assignments
      : [];
    const rules = getApplicableZipcodeRules(productData, zipcodeConfig);

    if (!/^\d{6}$/.test(normalizedPincode)) {
      return {
        ok: false,
        message: "Enter a 6-digit pincode to continue.",
        pincode: normalizedPincode,
        idle: !normalizedPincode,
      };
    }

    if (!allRules.length) {
      return {
        ok: false,
        message: defaultMessage,
        pincode: normalizedPincode,
      };
    }

    if (!rules.length) {
      return {
        ok: false,
        message: assignments.length
          ? "No delivery rule is assigned to this product."
          : defaultMessage,
        pincode: normalizedPincode,
      };
    }

    const blacklist = rules.filter((rule) => rule.ruleType === "blacklist");
    const whitelist = rules.filter((rule) => rule.ruleType !== "blacklist");

    for (const rule of blacklist) {
      if (zipMatches(rule, normalizedPincode)) {
        return {
          ok: false,
          message: zipcodeConfig.unavailableText,
          pincode: normalizedPincode,
        };
      }
    }

    if (!whitelist.length) {
      return {
        ok: true,
        message: zipcodeConfig.availableText,
        pincode: normalizedPincode,
      };
    }

    if (!whitelist.some(ruleHasZipCoverage)) {
      return {
        ok: false,
        message: defaultMessage,
        pincode: normalizedPincode,
      };
    }

    for (const rule of whitelist) {
      if (zipMatches(rule, normalizedPincode)) {
        return {
          ok: true,
          message: zipcodeConfig.availableText,
          pincode: normalizedPincode,
        };
      }
    }

    return {
      ok: false,
      message: zipcodeConfig.unavailableText,
      pincode: normalizedPincode,
    };
  };

  const getIndianPincodeLookup = () => {
    if (window.CleanPincodeLookup?.isKnown) {
      return Promise.resolve(window.CleanPincodeLookup);
    }

    return new Promise((resolve, reject) => {
      const timeout = window.setTimeout(() => {
        document.removeEventListener(
          "clean:pincode:lookup-ready",
          handleLookupReady,
        );
        reject(new Error("The shared pincode lookup is unavailable."));
      }, 10_000);

      function handleLookupReady() {
        if (!window.CleanPincodeLookup?.isKnown) return;

        window.clearTimeout(timeout);
        resolve(window.CleanPincodeLookup);
      }

      document.addEventListener(
        "clean:pincode:lookup-ready",
        handleLookupReady,
        { once: true },
      );
    });
  };

  const getIstParts = (date = new Date()) => {
    const byType = {};

    for (const part of IST_PARTS_FORMATTER.formatToParts(date)) {
      byType[part.type] = part.value;
    }

    const year = Number(byType.year);
    const month = Number(byType.month);
    const day = Number(byType.day);
    const utcDate = new Date(Date.UTC(year, month - 1, day));

    return {
      year,
      month,
      day,
      hour: Number(byType.hour),
      minute: Number(byType.minute),
      second: Number(byType.second),
      weekday: utcDate.getUTCDay(),
    };
  };

  const plainDateToUtcDate = (plainDate) =>
    new Date(Date.UTC(plainDate.year, plainDate.month - 1, plainDate.day));

  const utcDateToPlainDate = (date) => ({
    year: date.getUTCFullYear(),
    month: date.getUTCMonth() + 1,
    day: date.getUTCDate(),
    weekday: date.getUTCDay(),
  });

  const addDays = (plainDate, days) => {
    const date = plainDateToUtcDate(plainDate);
    date.setUTCDate(date.getUTCDate() + days);
    return utcDateToPlainDate(date);
  };

  const pad2 = (value) => String(value).padStart(2, "0");

  const toIsoDate = (plainDate) =>
    `${plainDate.year}-${pad2(plainDate.month)}-${pad2(plainDate.day)}`;

  const parseIsoDate = (value) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ""));
    if (!match) return null;

    const plainDate = {
      year: Number(match[1]),
      month: Number(match[2]),
      day: Number(match[3]),
    };
    const utcDate = plainDateToUtcDate(plainDate);

    if (
      utcDate.getUTCFullYear() !== plainDate.year ||
      utcDate.getUTCMonth() + 1 !== plainDate.month ||
      utcDate.getUTCDate() !== plainDate.day
    ) {
      return null;
    }

    return { ...plainDate, weekday: utcDate.getUTCDay() };
  };

  const formatHumanDate = (isoDate) => {
    const plainDate = parseIsoDate(isoDate);
    if (!plainDate) return "";

    return `${plainDate.day} ${MONTH_NAMES[plainDate.month - 1]}, ${plainDate.year}`;
  };

  const formatWeekday = (isoDate) => {
    const plainDate = parseIsoDate(isoDate);
    return plainDate ? DAY_NAMES[plainDate.weekday] : "";
  };

  const getMonthId = (plainDate) => plainDate.year * 12 + plainDate.month;

  const shiftMonth = (plainDate, offset) => {
    const date = new Date(
      Date.UTC(plainDate.year, plainDate.month - 1 + offset, 1),
    );
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: 1,
      weekday: date.getUTCDay(),
    };
  };

  const getDaysInMonth = (plainDate) =>
    new Date(Date.UTC(plainDate.year, plainDate.month, 0)).getUTCDate();

  const timeToMinutes = (value, fallback = 0) => {
    const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(String(value || ""));
    if (!match) return fallback;
    return Number(match[1]) * 60 + Number(match[2]);
  };

  const getLeadDays = (dateRule, weekday) =>
    intValue(dateRule.leadDays?.[weekday] ?? dateRule.leadDays?.default, 0);

  const isDateSelectable = (plainDate, dateRule) => {
    const weekdays = Array.isArray(dateRule.availableWeekdays)
      ? dateRule.availableWeekdays.map(Number)
      : [0, 1, 2, 3, 4, 5, 6];
    const disabledDates = new Set(dateRule.disabledDates || []);

    return (
      weekdays.includes(plainDate.weekday) &&
      !disabledDates.has(toIsoDate(plainDate))
    );
  };

  const findNextSelectableDate = (plainDate, dateRule, maxDate) => {
    let candidate = plainDate;

    for (let index = 0; index <= 370; index += 1) {
      if (toIsoDate(candidate) > toIsoDate(maxDate)) return plainDate;
      if (isDateSelectable(candidate, dateRule)) return candidate;
      candidate = addDays(candidate, 1);
    }

    return plainDate;
  };

  const getDateWindow = (rule, config) => {
    const dateRule = rule.dateRule || DEFAULT_CONFIG.dateRules[0];
    const now = getIstParts();
    const today = {
      year: now.year,
      month: now.month,
      day: now.day,
      weekday: now.weekday,
    };
    const cutoffMinutes = timeToMinutes(
      dateRule.cutoffTime || "23:59",
      23 * 60 + 59,
    );
    const nowMinutes = now.hour * 60 + now.minute;
    const basisDate = nowMinutes >= cutoffMinutes ? addDays(today, 1) : today;
    const earliestDate = addDays(
      basisDate,
      getLeadDays(dateRule, basisDate.weekday),
    );
    const maxDaysAhead = intValue(
      dateRule.maxDaysAhead,
      config.maxDaysAhead || MAX_DAYS_AHEAD,
    );
    const maxDate = addDays(today, maxDaysAhead);
    const firstDate = findNextSelectableDate(earliestDate, dateRule, maxDate);

    return {
      min: toIsoDate(firstDate),
      max: toIsoDate(maxDate),
    };
  };

  const renderTimeSlots = (picker, rule) => {
    const select = picker.querySelector("[data-clean-delivery-time-select]");
    if (!select) return;

    const slots = Array.isArray(rule.timeSlotRule?.slots)
      ? rule.timeSlotRule.slots
      : [];
    const renderKey = `${rule.id || ""}:${rule.timeSlotRule?.id || ""}:${slots.length}`;
    if (select.dataset.cleanDeliveryRendered === renderKey) return;

    select.dataset.cleanDeliveryRendered = renderKey;
    select.innerHTML = [
      '<option value="">Select time slot</option>',
      ...slots.map((slot) => {
        const startMinutes = timeToMinutes(slot.start, 0);
        const label = escapeHtml(slot.label || "");
        return `
          <option value="${label}" data-clean-delivery-time-option data-clean-delivery-slot-start="${startMinutes}">
            ${label}
          </option>
        `;
      }),
    ].join("");
  };

  const clearOwnButtonState = (button) => {
    if (!button || button.dataset.cleanDeliveryDisabled !== "true") return;

    button.disabled = false;
    button.removeAttribute("aria-disabled");
    button.classList.remove("is-disabled");
    delete button.dataset.cleanDeliveryDisabled;
  };

  const applyButtonState = (button, isValid) => {
    if (!button) return;

    button.dataset.cleanDeliveryValid = String(isValid);

    // Delivery requirements are validated when the customer tries to add the
    // item. Keep the button interactive here; inventory and app-owned states
    // can still disable it independently.
    clearOwnButtonState(button);
  };

  const initPicker = (picker) => {
    if (picker.dataset.cleanDeliveryReady === "true") return;

    const productSection = picker.closest(".clean-main-product");
    const productForm = productSection?.querySelector(
      "[data-clean-product-form]",
    );
    const submitButton = productForm?.querySelector(
      "[data-clean-product-submit]",
    );
    const dateTrigger = picker.querySelector(
      "[data-clean-delivery-date-trigger]",
    );
    const dateField = picker.querySelector("[data-clean-delivery-date-field]");
    const dateText = picker.querySelector("[data-clean-delivery-date-text]");
    const calendar = picker.querySelector("[data-clean-delivery-calendar]");
    const timeGroup = picker.querySelector("[data-clean-delivery-time-group]");
    const timeSelect = picker.querySelector(
      "[data-clean-delivery-time-select]",
    );
    const dateProperty = picker.querySelector(
      "[data-clean-delivery-date-property]",
    );
    const dayProperty = picker.querySelector(
      "[data-clean-delivery-day-property]",
    );
    const timeProperty = picker.querySelector(
      "[data-clean-delivery-time-property]",
    );
    const status = picker.querySelector("[data-clean-delivery-status]");
    const zipcodeValidator = productSection?.querySelector(
      "[data-clean-zipcode-validator]",
    );
    const zipcodeInput = zipcodeValidator?.querySelector(
      "[data-clean-zipcode-input]",
    );
    const zipcodeCheck = zipcodeValidator?.querySelector(
      "[data-clean-zipcode-check]",
    );
    const zipcodeStatus = zipcodeValidator?.querySelector(
      "[data-clean-zipcode-status]",
    );
    const zipcodePincodeProperty = zipcodeValidator?.querySelector(
      "[data-clean-zipcode-pincode-property]",
    );
    const zipcodeCard = productSection?.querySelector(
      "[data-clean-zipcode-card]",
    );
    const schedule = productSection?.querySelector(
      "[data-clean-delivery-schedule]",
    );
    if (
      !productForm ||
      !dateTrigger ||
      !dateText ||
      !calendar ||
      !timeGroup ||
      !timeSelect ||
      !dateProperty ||
      !dayProperty ||
      !timeProperty ||
      !submitButton
    )
      return;

    picker.dataset.cleanDeliveryReady = "true";

    const productData = parseProductData(picker);
    const config = parseConfigData(picker);
    const baseRule = getRule(productData, config);
    const standardRule = getDateOnlyRule(config, "standard");
    const sameDayRule = getSameDayRule(config);
    const productDeliveryFlow = getProductDeliveryFlow(productData);
    let rule = baseRule;
    const zipcodeConfig = config.zipcodeValidation || clone(ZIPCODE_DEFAULT);
    const applicableZipcodeRules = getApplicableZipcodeRules(
      productData,
      zipcodeConfig,
    );
    const hasZipcodeControls = Boolean(
      zipcodeValidator &&
      zipcodeInput &&
      zipcodeStatus &&
      zipcodePincodeProperty,
    );
    const hasAssignedZipcodeRules =
      hasZipcodeControls &&
      zipcodeConfig.enabled === true &&
      zipcodeConfig.visibility?.showOnProduct !== false &&
      applicableZipcodeRules.length > 0;
    const usesFallbackZipcode =
      hasZipcodeControls &&
      zipcodeValidator.dataset.cleanZipcodeFallback === "true" &&
      !hasAssignedZipcodeRules;
    const hasZipcodeValidator = hasAssignedZipcodeRules || usesFallbackZipcode;
    const requiresZipcodeForSubmit =
      usesFallbackZipcode ||
      (hasAssignedZipcodeRules && zipcodeConfig.blockAddToCart === true);
    let dateWindow = getDateWindow(rule, config);
    let minDate = parseIsoDate(dateWindow.min);
    let maxDate = parseIsoDate(dateWindow.max);
    let selectedDate = "";
    let viewMonth = minDate ? { ...minDate, day: 1 } : null;
    let selectedTime = "";
    let timeOptions = [];
    let deliveryMode = hasZipcodeValidator ? "idle" : "standard";
    let dateConfirmed = false;
    let previousPincode = "";
    let zipcodeResult = {
      ok: !hasZipcodeValidator || !requiresZipcodeForSubmit,
      message: "",
      pincode: "",
      idle: true,
    };
    let zipcodeTouched = false;
    let zipcodeDebounceTimer = null;
    let zipcodeValidationSequence = 0;
    let attentionTimer = null;
    let attentionScrollCleanup = null;
    let calendarScrollFrame = 0;

    dateProperty.disabled = false;
    dayProperty.disabled = false;

    if (zipcodeValidator) {
      zipcodeValidator.hidden = !hasZipcodeValidator;
    }

    if (hasZipcodeValidator) {
      zipcodeInput.placeholder = ZIPCODE_DEFAULT.placeholder;
      zipcodePincodeProperty.disabled = true;
    }

    const disableZipcodeProperty = () => {
      if (!hasZipcodeValidator) return;

      zipcodePincodeProperty.value = "";
      zipcodePincodeProperty.disabled = true;
    };

    const configureTimeSlots = () => {
      if (rule.timeRequired) {
        renderTimeSlots(picker, rule);
        timeOptions = Array.from(
          timeSelect.querySelectorAll("[data-clean-delivery-time-option]"),
        );
        timeGroup.hidden = false;
        timeGroup.disabled = false;
        timeSelect.disabled = false;
        timeSelect.required = true;
        return;
      }

      timeGroup.hidden = true;
      timeGroup.disabled = true;
      timeSelect.disabled = true;
      timeSelect.required = false;
      timeSelect.value = "";
      selectedTime = "";
      timeProperty.value = "";
      timeProperty.disabled = true;
    };

    const resetDateWindow = (nextRule) => {
      rule = nextRule;
      dateWindow = getDateWindow(rule, config);
      minDate = parseIsoDate(dateWindow.min);
      maxDate = parseIsoDate(dateWindow.max);

      if (selectedDate) {
        const parsedSelectedDate = parseIsoDate(selectedDate);
        if (
          !parsedSelectedDate ||
          selectedDate < dateWindow.min ||
          selectedDate > dateWindow.max ||
          !isDateSelectable(parsedSelectedDate, rule.dateRule)
        ) {
          selectedDate = "";
        }
      }

      viewMonth = parseIsoDate(selectedDate)
        ? { ...parseIsoDate(selectedDate), day: 1 }
        : minDate
          ? { ...minDate, day: 1 }
          : null;
    };

    const syncZipcodeProperty = (isModeValid) => {
      if (!hasZipcodeValidator) return;

      if (
        !isModeValid ||
        !zipcodeResult.ok ||
        !/^\d{6}$/.test(zipcodeResult.pincode || "")
      ) {
        disableZipcodeProperty();
        return;
      }

      zipcodePincodeProperty.disabled = false;
      zipcodePincodeProperty.value = zipcodeResult.pincode;
    };

    const getRuleForProductFlow = () => {
      if (productDeliveryFlow === "same_day") return sameDayRule;
      return standardRule;
    };

    const setDeliveryModeFromZipcode = () => {
      if (!hasZipcodeValidator) {
        deliveryMode = "standard";
        dateConfirmed = false;
        previousPincode = "";
        resetDateWindow(baseRule);
        return;
      }

      if (!zipcodeResult.ok && !requiresZipcodeForSubmit) {
        deliveryMode = "standard";
        dateConfirmed = false;
        previousPincode = "";
        resetDateWindow(getRuleForProductFlow());
        return;
      }

      if (!zipcodeResult.ok) {
        deliveryMode = zipcodeResult.idle ? "idle" : "unavailable";
        dateConfirmed = false;
        previousPincode = "";
        resetDateWindow(getRuleForProductFlow());
        return;
      }

      if (zipcodeResult.pincode !== previousPincode) {
        dateConfirmed = false;
        previousPincode = zipcodeResult.pincode;
      }

      if (productDeliveryFlow === "same_day") {
        deliveryMode = "same_day";
        resetDateWindow(sameDayRule);
        return;
      }

      deliveryMode = "standard";
      resetDateWindow(standardRule);
    };

    const syncModeUi = () => {
      if (!hasZipcodeValidator) {
        if (schedule) schedule.hidden = false;
        if (dateField) dateField.hidden = false;
        configureTimeSlots();
        return;
      }

      const hasConfirmedZipcode =
        zipcodeResult.ok === true &&
        /^\d{6}$/.test(zipcodeResult.pincode || "");

      if (zipcodeCard) zipcodeCard.dataset.cleanDeliveryMode = deliveryMode;
      if (schedule) schedule.hidden = !hasConfirmedZipcode;
      if (dateField) dateField.hidden = !hasConfirmedZipcode;

      configureTimeSlots();

      if (productDeliveryFlow === "same_day" && !dateConfirmed) {
        timeGroup.hidden = true;
        timeGroup.disabled = true;
        timeSelect.disabled = true;
        timeSelect.value = "";
        selectedTime = "";
        timeProperty.value = "";
        timeProperty.disabled = true;
      }
    };

    const renderCalendar = () => {
      if (!viewMonth || !minDate || !maxDate) return;

      const firstDay = new Date(
        Date.UTC(viewMonth.year, viewMonth.month - 1, 1),
      );
      const daysInMonth = getDaysInMonth(viewMonth);
      const titleId = `${dateTrigger.id}-calendar-title`;
      const calendarTitle = `${MONTH_NAMES[viewMonth.month - 1]} ${viewMonth.year}`;
      const canGoPrevious = getMonthId(viewMonth) > getMonthId(minDate);
      const canGoNext = getMonthId(viewMonth) < getMonthId(maxDate);
      const leadingDays = Array.from(
        { length: firstDay.getUTCDay() },
        () =>
          '<span class="clean-delivery-picker__calendar-empty" aria-hidden="true"></span>',
      ).join("");
      const dayButtons = Array.from({ length: daysInMonth }, (_, index) => {
        const day = index + 1;
        const plainDate = {
          year: viewMonth.year,
          month: viewMonth.month,
          day,
          weekday: new Date(
            Date.UTC(viewMonth.year, viewMonth.month - 1, day),
          ).getUTCDay(),
        };
        const isoDate = toIsoDate(plainDate);
        const isDisabled =
          isoDate < dateWindow.min ||
          isoDate > dateWindow.max ||
          !isDateSelectable(plainDate, rule.dateRule);
        const isSelected = isoDate === selectedDate;

        return `
          <button
            class="clean-delivery-picker__calendar-day${isSelected ? " is-selected" : ""}"
            type="button"
            data-clean-delivery-calendar-day="${isoDate}"
            aria-label="${formatHumanDate(isoDate)}"
            aria-pressed="${isSelected ? "true" : "false"}"
            ${isDisabled ? "disabled" : ""}
          >${day}</button>
        `;
      }).join("");

      calendar.setAttribute("role", "dialog");
      calendar.setAttribute("aria-modal", "false");
      calendar.setAttribute("aria-labelledby", titleId);
      calendar.innerHTML = `
        <div class="clean-delivery-picker__calendar-header">
          <button
            class="clean-delivery-picker__calendar-nav"
            type="button"
            aria-label="Previous month"
            data-clean-delivery-calendar-prev
            ${canGoPrevious ? "" : "disabled"}
          >&lt;</button>
          <div class="clean-delivery-picker__calendar-title" id="${titleId}">
            ${calendarTitle}
          </div>
          <button
            class="clean-delivery-picker__calendar-nav"
            type="button"
            aria-label="Next month"
            data-clean-delivery-calendar-next
            ${canGoNext ? "" : "disabled"}
          >&gt;</button>
        </div>
        <div class="clean-delivery-picker__calendar-weekdays" aria-hidden="true">
          ${SHORT_DAY_NAMES.map(
            (dayName) =>
              `<span class="clean-delivery-picker__calendar-weekday">${dayName}</span>`,
          ).join("")}
        </div>
        <div class="clean-delivery-picker__calendar-grid">
          ${leadingDays}${dayButtons}
        </div>
      `;
    };

    const closeCalendar = ({ restoreFocus = false } = {}) => {
      if (calendar.hidden) return;

      window.cancelAnimationFrame(calendarScrollFrame);
      calendar.hidden = true;
      dateTrigger.setAttribute("aria-expanded", "false");
      document.removeEventListener(
        "pointerdown",
        handleOutsidePointerDown,
        true,
      );
      document.removeEventListener("keydown", handleDocumentKeydown);

      if (restoreFocus) dateTrigger.focus({ preventScroll: true });
    };

    const openCalendar = () => {
      if (!calendar.hidden) return;

      renderCalendar();
      calendar.hidden = false;
      dateTrigger.setAttribute("aria-expanded", "true");
      document.addEventListener("pointerdown", handleOutsidePointerDown, true);
      document.addEventListener("keydown", handleDocumentKeydown);

      window.cancelAnimationFrame(calendarScrollFrame);
      calendarScrollFrame = window.requestAnimationFrame(() => {
        picker.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
            .matches
            ? "auto"
            : "smooth",
          block: "end",
        });
      });
    };

    const toggleCalendar = () => {
      if (calendar.hidden) {
        openCalendar();
      } else {
        closeCalendar();
      }
    };

    const updateTimeSlotAvailability = () => {
      if (!rule.timeRequired) return;

      const now = selectedDate ? getIstParts() : null;
      const preparationMinutes = intValue(
        rule.timeSlotRule?.preparationMinutes,
        0,
      );
      const today = now
        ? toIsoDate({
            year: now.year,
            month: now.month,
            day: now.day,
            weekday: now.weekday,
          })
        : "";
      const shouldDisableStartedSlots =
        Boolean(selectedDate) && selectedDate === today;
      const currentMinutes = shouldDisableStartedSlots
        ? now.hour * 60 + now.minute + preparationMinutes
        : -1;

      timeOptions.forEach((timeOption) => {
        const slotStart = Number.parseInt(
          timeOption.dataset.cleanDeliverySlotStart,
          10,
        );
        const isDisabled =
          shouldDisableStartedSlots &&
          Number.isFinite(slotStart) &&
          currentMinutes >= slotStart;

        timeOption.disabled = isDisabled;
        timeOption.hidden =
          isDisabled && rule.timeSlotRule?.hideUnavailableSlots !== false;

        if (isDisabled && timeOption.selected) {
          timeSelect.value = "";
          selectedTime = "";
        }
      });
    };

    const isSelectedDateValid = () => {
      const plainDate = parseIsoDate(selectedDate);
      return (
        Boolean(plainDate) &&
        selectedDate >= dateWindow.min &&
        selectedDate <= dateWindow.max &&
        isDateSelectable(plainDate, rule.dateRule)
      );
    };

    const dispatchZipcodeChange = (source = "product", country) => {
      if (!zipcodeValidator) return;

      zipcodeValidator.dispatchEvent(
        new CustomEvent("clean:zipcode:change", {
          bubbles: true,
          detail: {
            source,
            country,
            ok: zipcodeResult.ok === true,
            pincode: zipcodeResult.pincode || "",
            message: zipcodeResult.message || "",
            idle: zipcodeResult.idle === true,
            blockAddToCart: requiresZipcodeForSubmit,
          },
        }),
      );
    };

    const syncZipcodeUi = () => {
      if (!hasZipcodeValidator) return true;

      const isComplete = /^\d{6}$/.test(zipcodeResult.pincode || "");
      const isValidForSubmit =
        !requiresZipcodeForSubmit || zipcodeResult.ok === true;

      zipcodeStatus.classList.remove(
        "is-available",
        "is-unavailable",
        "is-error",
      );

      if (zipcodeResult.ok) {
        zipcodeStatus.textContent = "Available";
        zipcodeStatus.classList.add("is-available");
      } else if (zipcodeResult.pending) {
        zipcodeStatus.textContent = "Checking...";
      } else if (zipcodeTouched) {
        zipcodeStatus.textContent =
          zipcodeResult.message ||
          (isComplete
            ? zipcodeConfig.unavailableText
            : "Enter a 6-digit pincode to continue.");
        zipcodeStatus.classList.add(isComplete ? "is-unavailable" : "is-error");
      } else {
        zipcodeStatus.textContent = "";
      }

      return isValidForSubmit;
    };

    const persistValidatedPincode = () => {
      if (zipcodeConfig.persistLastPincode === false) return;

      try {
        if (zipcodeResult.ok && zipcodeResult.pincode) {
          localStorage.setItem("clean_last_pincode", zipcodeResult.pincode);
        } else if (!usesFallbackZipcode && zipcodeResult.pincode) {
          localStorage.setItem("clean_last_pincode", zipcodeResult.pincode);
        } else {
          localStorage.removeItem("clean_last_pincode");
        }
      } catch (error) {}
    };

    const getUncheckedFallbackResult = (value) => {
      const pincode = normalizePincode(value);

      return {
        ok: false,
        message: "Enter a 6-digit pincode to continue.",
        pincode,
        idle: !pincode,
      };
    };

    const validateZipcode = async ({
      touched = true,
      source = "product",
      country,
    } = {}) => {
      if (!hasZipcodeValidator) return true;

      zipcodeInput.value = normalizePincode(zipcodeInput.value);
      if (touched) zipcodeTouched = true;

      if (!usesFallbackZipcode) {
        zipcodeResult = checkZipcode(
          zipcodeInput.value,
          productData,
          zipcodeConfig,
        );
        persistValidatedPincode();
        syncProperties();
        dispatchZipcodeChange(source, country);

        return !requiresZipcodeForSubmit || zipcodeResult.ok === true;
      }

      const pincode = zipcodeInput.value;
      const validationSequence = ++zipcodeValidationSequence;

      if (!/^\d{6}$/.test(pincode)) {
        zipcodeResult = getUncheckedFallbackResult(pincode);
        persistValidatedPincode();
        syncProperties();
        dispatchZipcodeChange(source, country);
        return false;
      }

      zipcodeResult = {
        ok: false,
        message: "Checking pincode...",
        pincode,
        idle: false,
        pending: true,
      };
      syncProperties();
      dispatchZipcodeChange(source, country);

      try {
        const lookup = await getIndianPincodeLookup();
        const isKnown = await lookup.isKnown(pincode);

        if (
          validationSequence !== zipcodeValidationSequence ||
          pincode !== normalizePincode(zipcodeInput.value)
        ) {
          return false;
        }

        zipcodeResult = {
          ok: isKnown,
          message: isKnown
            ? "Delivery available"
            : "Enter a valid Indian pincode.",
          pincode,
          idle: false,
        };
      } catch (error) {
        if (validationSequence !== zipcodeValidationSequence) return false;

        zipcodeResult = {
          ok: false,
          message:
            "Pincode validation is temporarily unavailable. Please try again.",
          pincode,
          idle: false,
        };
      }

      persistValidatedPincode();
      syncProperties();
      dispatchZipcodeChange(source, country);

      return zipcodeResult.ok === true;
    };

    const syncRestoredControlValues = () => {
      selectedTime = timeSelect.value || "";

      if (hasZipcodeValidator) {
        zipcodeInput.value = normalizePincode(zipcodeInput.value);
        zipcodeTouched = zipcodeTouched || Boolean(zipcodeInput.value);
        zipcodeResult = usesFallbackZipcode
          ? getUncheckedFallbackResult(zipcodeInput.value)
          : checkZipcode(zipcodeInput.value, productData, zipcodeConfig);
      }

      syncProperties();
      dispatchZipcodeChange("restoration");
    };

    const showDeliveryRequirementsMet = (mode, hasValidDate, hasValidTime) => {
      if (!requiresZipcodeForSubmit) return hasValidDate && hasValidTime;
      if (mode === "same_day") return hasValidDate && hasValidTime;
      if (mode === "standard") return hasValidDate;
      return false;
    };

    const syncProperties = () => {
      status?.classList.remove("is-error");
      setDeliveryModeFromZipcode();
      syncModeUi();
      updateTimeSlotAvailability();

      const hasValidDate = isSelectedDateValid();
      const hasConfirmedDate =
        productDeliveryFlow !== "same_day" ||
        !hasZipcodeValidator ||
        dateConfirmed;
      const validSelectedDate = hasValidDate ? selectedDate : "";
      const deliveryDay = validSelectedDate
        ? formatWeekday(validSelectedDate)
        : "";
      const deliveryDate = validSelectedDate
        ? formatHumanDate(validSelectedDate)
        : "";
      const displayDeliveryDate =
        productDeliveryFlow === "same_day" &&
        hasZipcodeValidator &&
        !dateConfirmed
          ? ""
          : deliveryDate;
      const hasValidTime = !rule.timeRequired || Boolean(selectedTime);
      const isZipcodeValid = syncZipcodeUi();
      const isModeComplete =
        !requiresZipcodeForSubmit ||
        deliveryMode === "same_day" ||
        deliveryMode === "standard";
      const isDeliveryValid = showDeliveryRequirementsMet(
        deliveryMode,
        hasValidDate && hasConfirmedDate,
        hasValidTime,
      );
      const isValid = isDeliveryValid && isZipcodeValid && isModeComplete;

      dateText.textContent = displayDeliveryDate || "Select delivery date";
      dateTrigger.setAttribute(
        "aria-label",
        displayDeliveryDate
          ? `Delivery Date, ${displayDeliveryDate}`
          : "Delivery Date",
      );
      dateProperty.value = deliveryDate;
      dayProperty.value = deliveryDay;
      dateProperty.disabled = hasZipcodeValidator && !isValid;
      dayProperty.disabled = hasZipcodeValidator && !isValid;

      if (
        rule.timeRequired &&
        selectedTime &&
        (!hasZipcodeValidator || isValid)
      ) {
        timeProperty.disabled = false;
        timeProperty.value = selectedTime;
      } else {
        timeProperty.value = "";
        timeProperty.disabled = true;
      }

      if (status) {
        status.hidden = false;
        if (hasZipcodeValidator && deliveryMode === "idle") {
          status.textContent = "";
        } else if (hasZipcodeValidator && deliveryMode === "unavailable") {
          status.textContent = "Delivery is not available for this pincode.";
        } else if (
          productDeliveryFlow === "same_day" &&
          hasZipcodeValidator &&
          !dateConfirmed
        ) {
          status.textContent = "Select a delivery date to continue.";
        } else if (!hasValidDate) {
          status.textContent = "Select a delivery date to continue.";
        } else if (rule.timeRequired && !selectedTime) {
          status.textContent = "Select a delivery time to continue.";
        } else if (rule.timeRequired) {
          status.textContent = `${deliveryDay}, ${deliveryDate} - ${selectedTime}`;
        } else {
          status.textContent = `${deliveryDay}, ${deliveryDate}`;
        }
      }

      syncZipcodeProperty(isValid);
      applyButtonState(submitButton, isValid);
      productForm.dispatchEvent(
        new CustomEvent("clean:delivery:change", {
          bubbles: true,
          detail: {
            mode: deliveryMode,
            valid: isValid,
          },
        }),
      );

      return isValid;
    };

    const isControlVisible = (control) =>
      Boolean(control && !control.disabled && !control.closest("[hidden]"));

    const clearAttentionState = () => {
      window.clearTimeout(attentionTimer);
      attentionScrollCleanup?.();
      attentionScrollCleanup = null;
      [zipcodeInput, dateTrigger, timeSelect].forEach((control) => {
        if (!control) return;

        control.classList.remove("is-attention-required", "is-attention-bump");
        control.removeAttribute("aria-invalid");
      });
    };

    const playAttentionAnimation = (control) => {
      // Restart the transform-only animation on repeated ATC attempts.
      void control.offsetWidth;
      control.classList.add("is-attention-bump");
      attentionTimer = window.setTimeout(
        () => control.classList.remove("is-attention-bump"),
        450,
      );
    };

    const playAttentionAfterScroll = (control) => {
      let settleTimer = null;
      let fallbackTimer = null;
      let finished = false;

      const cleanup = () => {
        window.clearTimeout(settleTimer);
        window.clearTimeout(fallbackTimer);
        document.removeEventListener("scroll", handleScroll, true);
        if (attentionScrollCleanup === cleanup) attentionScrollCleanup = null;
      };
      const finish = () => {
        if (finished) return;

        finished = true;
        cleanup();
        playAttentionAnimation(control);
      };
      const handleScroll = () => {
        window.clearTimeout(fallbackTimer);
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(finish, 120);
      };

      attentionScrollCleanup = cleanup;
      document.addEventListener("scroll", handleScroll, {
        capture: true,
        passive: true,
      });
      fallbackTimer = window.setTimeout(finish, 1200);
    };

    const drawAttentionTo = (control, message, messageElement) => {
      if (!control || !isControlVisible(control)) return false;

      clearAttentionState();
      control.classList.add("is-attention-required");
      control.setAttribute("aria-invalid", "true");

      if (messageElement) {
        messageElement.textContent = message;
        messageElement.classList.add("is-error");
      }

      const bounds = control.getBoundingClientRect();
      const needsScroll =
        bounds.top < 80 || bounds.bottom > window.innerHeight - 90;
      if (needsScroll) {
        playAttentionAfterScroll(control);
        control.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
            .matches
            ? "auto"
            : "smooth",
          block: "center",
        });
      } else {
        playAttentionAnimation(control);
      }

      control.focus({ preventScroll: true });
      return true;
    };

    const promptForFirstIncompleteField = () => {
      syncProperties();

      if (
        hasZipcodeValidator &&
        zipcodeResult.ok !== true &&
        isControlVisible(zipcodeInput)
      ) {
        validateZipcode({ touched: true });
        return drawAttentionTo(
          zipcodeInput,
          zipcodeResult.message ||
            "Enter a valid 6-digit delivery pincode to continue.",
          zipcodeStatus,
        );
      }

      const needsDate =
        !isSelectedDateValid() ||
        (productDeliveryFlow === "same_day" &&
          hasZipcodeValidator &&
          !dateConfirmed);
      if (needsDate && isControlVisible(dateTrigger)) {
        return drawAttentionTo(
          dateTrigger,
          "Choose a delivery date to continue.",
          status,
        );
      }

      if (rule.timeRequired && !selectedTime && isControlVisible(timeSelect)) {
        return drawAttentionTo(
          timeSelect,
          "Choose a delivery time slot to continue.",
          status,
        );
      }

      return false;
    };

    const isCustomeowActivation = (event) => {
      const eventPath =
        typeof event.composedPath === "function"
          ? event.composedPath()
          : [event.target];
      const hasCustomeowTarget = eventPath.some(
        (target) =>
          target instanceof Element &&
          (target.matches(
            'customeow-block-button, [data-type="customeowApp"]',
          ) ||
            target.closest(
              'customeow-block-button, [data-type="customeowApp"]',
            )),
      );
      const clickedSubmit =
        event.target instanceof Element
          ? event.target.closest("[data-clean-product-submit]")
          : null;
      const isCustomizeSubmit =
        clickedSubmit === submitButton &&
        submitButton.textContent.trim().toLowerCase() === "customize now";

      return hasCustomeowTarget || isCustomizeSubmit;
    };

    const guardCustomeowActivation = (event) => {
      if (!isCustomeowActivation(event) || syncProperties()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      promptForFirstIncompleteField();
    };

    function handleOutsidePointerDown(event) {
      if (event.target instanceof Node && picker.contains(event.target)) return;

      closeCalendar();
    }

    function handleDocumentKeydown(event) {
      if (event.key === "Escape") closeCalendar({ restoreFocus: true });
    }

    dateTrigger.addEventListener("click", toggleCalendar);

    productSection.addEventListener("click", guardCustomeowActivation, true);

    calendar.addEventListener("click", (event) => {
      if (!(event.target instanceof Element)) return;

      const previousButton = event.target.closest(
        "[data-clean-delivery-calendar-prev]",
      );
      const nextButton = event.target.closest(
        "[data-clean-delivery-calendar-next]",
      );
      const dayButton = event.target.closest(
        "[data-clean-delivery-calendar-day]",
      );

      if (previousButton && !previousButton.disabled) {
        viewMonth = shiftMonth(viewMonth, -1);
        renderCalendar();
        return;
      }

      if (nextButton && !nextButton.disabled) {
        viewMonth = shiftMonth(viewMonth, 1);
        renderCalendar();
        return;
      }

      if (!dayButton || dayButton.disabled) return;

      const nextDate = dayButton.dataset.cleanDeliveryCalendarDay || "";
      if (
        !parseIsoDate(nextDate) ||
        nextDate < dateWindow.min ||
        nextDate > dateWindow.max
      )
        return;

      selectedDate = nextDate;
      dateConfirmed = true;
      viewMonth = { ...parseIsoDate(selectedDate), day: 1 };
      clearAttentionState();
      syncProperties();
      closeCalendar();
    });

    picker.addEventListener("change", (event) => {
      const changedTimeSelect = event.target.closest(
        "[data-clean-delivery-time-select]",
      );
      if (!changedTimeSelect || !picker.contains(changedTimeSelect)) return;

      selectedTime = changedTimeSelect.value;
      clearAttentionState();
      syncProperties();
    });

    if (hasZipcodeValidator) {
      zipcodeInput.addEventListener("input", () => {
        clearAttentionState();
        zipcodeInput.value = normalizePincode(zipcodeInput.value);
        zipcodeTouched = true;
        window.clearTimeout(zipcodeDebounceTimer);

        if (zipcodeInput.value.length === 6) {
          zipcodeDebounceTimer = window.setTimeout(
            () => validateZipcode({ touched: true }),
            250,
          );
        } else {
          zipcodeValidationSequence += 1;
          zipcodeResult = usesFallbackZipcode
            ? getUncheckedFallbackResult(zipcodeInput.value)
            : checkZipcode(zipcodeInput.value, productData, zipcodeConfig);
          syncProperties();
          dispatchZipcodeChange();
        }
      });

      zipcodeInput.addEventListener("blur", () => {
        validateZipcode({ touched: true });
      });

      zipcodeInput.addEventListener("keydown", (event) => {
        if (event.key !== "Enter") return;

        event.preventDefault();
        validateZipcode({ touched: true });
      });

      zipcodeCheck?.addEventListener("click", () => {
        validateZipcode({ touched: true });
      });

      zipcodeValidator.addEventListener("clean:pincode:apply", (event) => {
        const nextPincode = normalizePincode(event.detail?.pincode);
        zipcodeInput.value = nextPincode;
        zipcodeTouched = Boolean(nextPincode);

        if (usesFallbackZipcode) {
          validateZipcode({
            touched: Boolean(nextPincode),
            source: event.detail?.source || "header",
            country: event.detail?.country,
          });
        } else {
          zipcodeResult = checkZipcode(nextPincode, productData, zipcodeConfig);
          syncProperties();
          dispatchZipcodeChange(
            event.detail?.source || "header",
            event.detail?.country,
          );
        }
      });
    }

    productForm.addEventListener("clean:variant:change", () => {
      clearAttentionState();
      syncProperties();
    });

    productForm.addEventListener(
      "clean:delivery:request-validation",
      promptForFirstIncompleteField,
    );

    productForm.addEventListener(
      "submit",
      (event) => {
        if (syncProperties()) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        promptForFirstIncompleteField();
      },
      true,
    );

    if (hasZipcodeValidator) {
      if (zipcodeConfig.persistLastPincode !== false) {
        try {
          const savedPincode = normalizePincode(
            localStorage.getItem("clean_last_pincode"),
          );
          if (savedPincode) {
            zipcodeInput.value = savedPincode;
            zipcodeTouched = true;
          }
        } catch (error) {}
      }

      zipcodeResult = usesFallbackZipcode
        ? getUncheckedFallbackResult(zipcodeInput.value)
        : checkZipcode(zipcodeInput.value, productData, zipcodeConfig);
    }

    syncRestoredControlValues();
    if (usesFallbackZipcode && /^\d{6}$/.test(zipcodeInput.value)) {
      validateZipcode({ touched: false, source: "restoration" });
    }

    window.addEventListener("pageshow", () => {
      syncRestoredControlValues();
      if (usesFallbackZipcode && /^\d{6}$/.test(zipcodeInput.value)) {
        validateZipcode({ touched: false, source: "restoration" });
      }
    });

    picker.dispatchEvent(
      new CustomEvent("clean:delivery-picker:ready", {
        bubbles: true,
        detail: { flow: productDeliveryFlow },
      }),
    );
  };

  const init = (root = document) => {
    root.querySelectorAll(PICKER_SELECTOR).forEach(initPicker);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) =>
    init(event.target),
  );
  window.addEventListener("pageshow", () => init());
  document.addEventListener(
    "pointerdown",
    (event) => {
      if (!(event.target instanceof Element)) return;

      const productSection = event.target.closest(".clean-main-product");
      if (productSection) init(productSection);
    },
    true,
  );
  document.addEventListener("focusin", (event) => {
    if (!(event.target instanceof Element)) return;

    const productSection = event.target.closest(".clean-main-product");
    if (productSection) init(productSection);
  });
})();
